import React from "react";

const NavigationDots = ({ active }) => (
  <div className="app__navigation">
    {["home", "about", "work", "skills", "testimonial", "contact"].map(
      (item, index) => (
        <a
          href={`#${item}`}
          key={item + index}
          className="app__navigation-dot"
          style={active === item ? { backgroundColor: "#4f8ecb" } : {}}
          aria-label={`Ir a ${item}`}
        >
          <span className="sr-only">{`Ir a ${item}`}</span>
        </a>
      )
    )}
  </div>
);

export default NavigationDots;
